import { ShimmerEffect } from "../ShimmerEffect"

export default function RajaBetsAdContainer({ imageUrl, redirectUrl, adClass }) {
    return (
        <>
            <a href={redirectUrl} target="_blank">
                <ShimmerEffect src={imageUrl} alt="raja-bet-ad-banner" className={adClass} />
            </a>
        </>
    )
}

RajaBetsAdContainer.defaultProps = {
    imageUrl: '',
    redirectUrl: 'https://www.raja.link/sportsgully',
    adClass: 'h-full w-full',
}